// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `GameMode`.
const GameMode = __t.enum("GameMode", {Solo: __t.unit(),
  Coop: __t.unit(),
  Race: __t.unit(),
  TurnTactics: __t.unit(),
  Ranked: __t.unit(),
});

export default GameMode;


